import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { IServicioDigital } from "@/shared/interfaces";
import { formatDateWithTime } from "@/shared";

type ServicioDigitalType = Partial<IServicioDigital>

export const useTableColumnsServicioDigital = () => {

  const columnsServicioDigital = useMemo<MRT_ColumnDef<ServicioDigitalType>[]>(() => [
    {
      accessorKey: 'nombre',
      header: 'Nombre',
      size: 300,
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      size: 300,
    },
    {
      accessorKey: 'precio1',
      header: 'Precio 1',
      size: 200,
      Cell: ({ row }) => (
        row.original.precios?.[0].precio || "N/A"
      )
    },
    {
      accessorKey: 'precio2',
      header: 'Precio 2',
      size: 200,
      Cell: ({ row }) => (
        row.original.precios?.[1].precio || "N/A"
      )
    },
    {
      accessorKey: 'precio3',
      header: 'Precio 3',
      size: 200,
      Cell: ({ row }) => (
        row.original.precios?.[2].precio || "N/A"
      )
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTime(row.original.fecha_creacion!)
      )
    },
    {
      accessorKey: 'fecha_modificacion',
      header: 'Fecha Modificación',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTime(row.original.fecha_modificacion!)
      )
    },


  ], [])



  return {
    columnsServicioDigital
  }
}